import React, { useEffect } from "react";
import "../roleManagement/RoleManagement.scss";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate, useLocation } from "react-router-dom";
import useForm from "./useForm";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import ErrorMessage from "../../components/common/ErrorMessage";
import { isRequired } from "../../utils/Validate";
import RoleManagementCard from "../../components/roleManagement/RoleManagementCard";
import RoleInformation from "../../components/roleManagement/RoleInformation";
import RolePermission from "../../components/roleManagement/RolePermission";
import { ValidateMessages } from "../../constants/ValidateConstants";

const AddNewUserRole = () => {
  const {
    parentMenuList,
    handleSubmit,
    values,
    setValues,
    subMenuList,
    setSubMenuList,
    menuList,
    handleFormChange,
    errors,
    show,
    setShow,
    createMsg,
    setCreateMsg,
    selectedParent,
    setSelectedParent,
    handleStatusChange,
    errorShow,
    setErrorShow,
    ErrorDoneClick,
    SuccessDoneClick,
    loading,
    setLoading,
    setErrors,
  } = useForm();

  const navigate = useNavigate();

  const handleCheck = (e, index) => {
    setErrors((prev) => {
      if (!prev?.roleCheck) return prev;
      const next = { ...prev };
      delete next.roleCheck;
      return next;
    });

    if (!values?.id) {
      const subMenu_ = [...subMenuList];
      const role_ = [...values?.rolePermissions];
      role_[index][e.target.id] = e.target.checked;
      //
      const indexi = subMenuList.indexOf(
        subMenuList.find((c) => c?.id === role_[index]?.id)
      );
      subMenu_[indexi] = { ...subMenu_[indexi], ...role_[index] };
      setSubMenuList(subMenu_);
      setValues({
        ...values,
        rolePermissions: role_,
      });
    } else {
      const role_ = [...values?.rolePermissions];
      const subMenu_ = [...values?.role];
      role_[index][e.target.id] = e.target.checked;
      const indexi = values?.role.indexOf(
        values?.role.find((c) => c?.id === role_[index]?.id)
      );
      subMenu_[indexi] = { ...subMenu_[indexi], ...role_[index] };
      setValues({
        ...values,
        role: subMenu_,
        rolePermissions: role_,
      });
    }
  };

  useEffect(() => {
    if (!values?.id) {
      const dta = subMenuList
        ?.filter((obj) => !obj?.isParent && obj?.menuParentId == selectedParent)
        .map((smb) => ({
          id: smb?.id,
          roleId: smb?.roleId ? smb?.roleId : "",
          menuId: smb?.menuId ? smb?.menuId : smb?.id,
          canAdd: smb?.canAdd || false,
          canView: smb?.canView || false,
          canEdit: smb?.canEdit || false,
          canDelete: smb?.canDelete || false,
          canPrint: smb?.canPrint || false,
          menuName: smb?.menuName,
        }));

      setValues({ ...values, rolePermissions: dta });
    } else {
      const userRoles = values?.role?.map((c) => ({
        ...c,
        menuName:
          subMenuList?.find((obj) => obj?.id === c?.menuId)?.menuName || "",
        menuParentId:
          subMenuList?.find((obj) => obj?.id === c?.menuId)?.menuParentId || "",
      }));

      const roles = userRoles?.filter(
        (ob) => ob?.menuParentId == selectedParent
      );

      setValues({ ...values, rolePermissions: roles });
    }
  }, [selectedParent, subMenuList]);

  const Validation = () => {
    const err_ = {};
    const filterRole = (values?.id ? values?.role : subMenuList).find(item => item.canAdd === true || item.canDelete === true || item.canEdit === true || item.canPrint === true || item.canView === true)
    err_["roleName"] = !isRequired(values?.roleName)
      ? "RoleName Required"
      : false;
    err_["roleCheck"] = filterRole === undefined ? ValidateMessages?.CHECK_ROLE : false;
    return err_
  }

  const handleSubmitValues = (e) => {
    e.preventDefault();
    const errors_ = Validation();
    if (Object.values(errors_)?.some((_) => _)) {
      setErrors(errors_);
      return;
    }
    setLoading(true);
    if (values?.id) {
      const newList = values?.role?.map((c) => {
        return {
          roleId: c?.roleId,
          menuId: c?.menuId,
          canAdd: c?.canAdd || false,
          canEdit: c?.canEdit || false,
          canView: c?.canView || false,
          canDelete: c?.canDelete || false,
          canPrint: c?.canPrint || false,
          id: c?.id,
        };
      });
      handleSubmit(newList);
    } else {
      const newList = subMenuList?.map((c) => {
        return {
          roleId: "",
          menuId: c?.menuId ? c?.menuId : c?.id,
          canAdd: c?.canAdd || false,
          canEdit: c?.canEdit || false,
          canView: c?.canView || false,
          canDelete: c?.canDelete || false,
          canPrint: c?.canPrint || false,
        };
      });
      handleSubmit(newList);
    }
  };

  const handleRedirect = () => {
    setValues({});
    navigate("/role-management");
  };

  const location = useLocation();

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
      detail: {
        pathname: location.pathname,
        title: values?.id ? "Edit Role" : "New Role",
        backTarget: { pathname: "/role-management" }, 
      },
    }));

    return () => {
      window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
        detail: {
          pathname: location.pathname,
          clear: true,
        },
      }));
    };
  }, [values?.id, location.pathname]);

  return (
    <div className="container-fluid add-new-role-sec">
      <section className="user-role-add-sec">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card">
              <div className="card-body">
                <RoleInformation
                  values={values}
                  errors={errors}
                  handleFormChange={handleFormChange}
                  handleStatusChange={handleStatusChange}
                  handleRedirect={handleRedirect}
                />
                <RolePermission
                  RoleManagementCard={RoleManagementCard}
                  parentMenuList={parentMenuList}
                  setSelectedParent={setSelectedParent}
                  values={values}
                  handleCheck={handleCheck}
                  handleRedirect={handleRedirect}
                  handleSubmitValues={handleSubmitValues}
                  loading={loading}
                  errors={errors}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- saveSuccessModal start--> */}
      <SaveSuccessModel
        createMsg={createMsg}
        setCreateMsg={setCreateMsg}
        setShow={setShow}
        show={show}
        SuccessDoneClick={SuccessDoneClick}
      />
      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />
    </div>
  );
};

export default AddNewUserRole;
